var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.saveEmailConfig()
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-6 my-2" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("settings.mail.driver")))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-select", {
              attrs: {
                invalid: _vm.$v.mailConfigData.mail_driver.$error,
                options: _vm.mailDrivers,
                searchable: true,
                "allow-empty": false,
                "show-labels": false
              },
              on: { input: _vm.onChangeDriver },
              model: {
                value: _vm.mailConfigData.mail_driver,
                callback: function($$v) {
                  _vm.$set(_vm.mailConfigData, "mail_driver", $$v)
                },
                expression: "mailConfigData.mail_driver"
              }
            }),
            _vm._v(" "),
            _vm.$v.mailConfigData.mail_driver.$error
              ? _c("div", [
                  !_vm.$v.mailConfigData.mail_driver.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.required")) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6 my-2" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("settings.mail.host")))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-input", {
              attrs: {
                invalid: _vm.$v.mailConfigData.mail_host.$error,
                type: "text",
                name: "mail_host"
              },
              on: {
                input: function($event) {
                  return _vm.$v.mailConfigData.mail_host.$touch()
                }
              },
              model: {
                value: _vm.mailConfigData.mail_host,
                callback: function($$v) {
                  _vm.$set(
                    _vm.mailConfigData,
                    "mail_host",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "mailConfigData.mail_host"
              }
            }),
            _vm._v(" "),
            _vm.$v.mailConfigData.mail_host.$error
              ? _c("div", [
                  !_vm.$v.mailConfigData.mail_host.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.required")) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row my-2" }, [
        _c(
          "div",
          { staticClass: "col-md-6 my-2" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("settings.mail.username")))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-input", {
              attrs: {
                invalid: _vm.$v.mailConfigData.mail_username.$error,
                type: "text",
                name: "db_name"
              },
              on: {
                input: function($event) {
                  return _vm.$v.mailConfigData.mail_username.$touch()
                }
              },
              model: {
                value: _vm.mailConfigData.mail_username,
                callback: function($$v) {
                  _vm.$set(
                    _vm.mailConfigData,
                    "mail_username",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "mailConfigData.mail_username"
              }
            }),
            _vm._v(" "),
            _vm.$v.mailConfigData.mail_username.$error
              ? _c("div", [
                  !_vm.$v.mailConfigData.mail_username.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.required")) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6 my-2" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("settings.mail.password")))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-input", {
              attrs: {
                invalid: _vm.$v.mailConfigData.mail_password.$error,
                type: "password",
                name: "name",
                "show-password": ""
              },
              on: {
                input: function($event) {
                  return _vm.$v.mailConfigData.mail_password.$touch()
                }
              },
              model: {
                value: _vm.mailConfigData.mail_password,
                callback: function($$v) {
                  _vm.$set(
                    _vm.mailConfigData,
                    "mail_password",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "mailConfigData.mail_password"
              }
            }),
            _vm._v(" "),
            _vm.$v.mailConfigData.mail_password.$error
              ? _c("div", [
                  !_vm.$v.mailConfigData.mail_password.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.required")) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row my-2" }, [
        _c(
          "div",
          { staticClass: "col-md-6 my-2" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("settings.mail.port")))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-input", {
              attrs: {
                invalid: _vm.$v.mailConfigData.mail_port.$error,
                type: "text",
                name: "mail_port"
              },
              on: {
                input: function($event) {
                  return _vm.$v.mailConfigData.mail_port.$touch()
                }
              },
              model: {
                value: _vm.mailConfigData.mail_port,
                callback: function($$v) {
                  _vm.$set(
                    _vm.mailConfigData,
                    "mail_port",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "mailConfigData.mail_port"
              }
            }),
            _vm._v(" "),
            _vm.$v.mailConfigData.mail_port.$error
              ? _c("div", [
                  !_vm.$v.mailConfigData.mail_port.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.required")) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.mailConfigData.mail_port.numeric
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.numbers_only")) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6 my-2" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("settings.mail.encryption")))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-select", {
              attrs: {
                invalid: _vm.$v.mailConfigData.mail_encryption.$error,
                options: _vm.encryptions,
                searchable: true,
                "show-labels": false
              },
              on: {
                input: function($event) {
                  return _vm.$v.mailConfigData.mail_encryption.$touch()
                }
              },
              model: {
                value: _vm.mailConfigData.mail_encryption,
                callback: function($$v) {
                  _vm.$set(
                    _vm.mailConfigData,
                    "mail_encryption",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "mailConfigData.mail_encryption"
              }
            }),
            _vm._v(" "),
            _vm.$v.mailConfigData.mail_encryption.$error
              ? _c("div", [
                  !_vm.$v.mailConfigData.mail_encryption.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.required")) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row my-2" }, [
        _c(
          "div",
          { staticClass: "col-md-6 my-2" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("settings.mail.from_mail")))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-input", {
              attrs: {
                invalid: _vm.$v.mailConfigData.from_mail.$error,
                type: "text",
                name: "from_mail"
              },
              on: {
                input: function($event) {
                  return _vm.$v.mailConfigData.from_mail.$touch()
                }
              },
              model: {
                value: _vm.mailConfigData.from_mail,
                callback: function($$v) {
                  _vm.$set(
                    _vm.mailConfigData,
                    "from_mail",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "mailConfigData.from_mail"
              }
            }),
            _vm._v(" "),
            _vm.$v.mailConfigData.from_mail.$error
              ? _c("div", [
                  !_vm.$v.mailConfigData.from_mail.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.required")) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.mailConfigData.from_mail.email
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.email_incorrect")) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6 my-2" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("settings.mail.from_name")))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("base-input", {
              attrs: {
                invalid: _vm.$v.mailConfigData.from_name.$error,
                type: "text",
                name: "from_name"
              },
              on: {
                input: function($event) {
                  return _vm.$v.mailConfigData.from_name.$touch()
                }
              },
              model: {
                value: _vm.mailConfigData.from_name,
                callback: function($$v) {
                  _vm.$set(
                    _vm.mailConfigData,
                    "from_name",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "mailConfigData.from_name"
              }
            }),
            _vm._v(" "),
            _vm.$v.mailConfigData.from_name.$error
              ? _c("div", [
                  !_vm.$v.mailConfigData.from_name.required
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("validation.required")) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c(
            "base-button",
            {
              staticClass: "pull-right mt-4",
              attrs: {
                loading: _vm.loading,
                icon: "save",
                color: "theme",
                type: "submit"
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("general.save")) + "\n    ")]
          ),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }